import styled from 'styled-components';
import ChevronRight from '../../assets/icons/chevronRight.svg?react';
import { Typography } from '../Typography/Typography';
import { RouterLink } from '../Button/Button';

const BreadcrumbNav = styled.nav`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

const CrumbCurrent = styled(Typography)`
  color: var(--grayscale-600);
`;

const Chevron = styled(ChevronRight)`
  width: 12px;
  height: 12px;
  color: var(--grayscale-200);
`;

const CrumbLink = styled(RouterLink)`
  color: var(--grayscale-600);
`;

type Crumb = {
  title: string;
  link: string;
};

export const Breadcrumb = ({ currentCrumb, prevCrumbs }: { currentCrumb: string; prevCrumbs: Crumb[] }) => {
  return (
    <BreadcrumbNav aria-label="Breadcrumb">
      {prevCrumbs.map((crumb, _) => (
        <div key={crumb.link}>
          <CrumbLink to={crumb.link}>{crumb.title}</CrumbLink>
          <Chevron aria-hidden />
        </div>
      ))}
      <CrumbCurrent renderedAs="span">{currentCrumb}</CrumbCurrent>
    </BreadcrumbNav>
  );
};

export default Breadcrumb;
